import { InfoItem } from "./InfoItem";

export default InfoItem;
